import getSelectedFolderView from '../selectors/getSelectedFolderView';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib';
import {
    moveTaskToTopOfList,
    moveTaskToEndOfList,
    moveTaskUpTheList,
    moveTaskDownTheList,
} from '../actions/dropActions';
import { getOwaTasksStrings } from 'owa-strings/owa-tasks-strings';

export default function getReorderContextMenuItem(itemId: string): IContextualMenuItem {
    const folderView = getSelectedFolderView();
    const indexOfItem = folderView.activeTaskIds.indexOf(itemId);
    const countOfItems = folderView.activeTaskIds.length;

    return {
        key: 'reorder_task',
        name: getOwaTasksStrings().moveInList,
        onClick: () => {},
        subMenuProps: {
            items: [
                getReorderMoveToTop(itemId, indexOfItem),
                getReorderMoveUp(itemId, indexOfItem),
                getReorderMoveDown(itemId, indexOfItem, countOfItems),
                getReorderMoveToEnd(itemId, indexOfItem, countOfItems),
            ],
        },
    };
}

function getReorderMoveToTop(itemId: string, indexOfItem: number): IContextualMenuItem {
    return {
        key: 'reorder_moveToTop',
        name: getOwaTasksStrings().moveToTop,
        onClick: () => {
            moveTaskToTopOfList(itemId);
        },
        disabled: indexOfItem <= 0,
    };
}

function getReorderMoveToEnd(
    itemId: string,
    indexOfItem: number,
    countOfItems: number
): IContextualMenuItem {
    return {
        key: 'reorder_moveToEnd',
        name: getOwaTasksStrings().moveToBottom,
        onClick: () => {
            moveTaskToEndOfList(itemId);
        },
        disabled: indexOfItem == countOfItems - 1,
    };
}

function getReorderMoveUp(itemId: string, indexOfItem: number): IContextualMenuItem {
    return {
        key: 'reorder_moveUp',
        name: getOwaTasksStrings().moveUp,
        onClick: () => {
            moveTaskUpTheList(itemId);
        },
        disabled: indexOfItem <= 0,
    };
}

function getReorderMoveDown(
    itemId: string,
    indexOfItem: number,
    countOfItems: number
): IContextualMenuItem {
    return {
        key: 'reorder_moveDown',
        name: getOwaTasksStrings().moveDown,
        onClick: () => {
            moveTaskDownTheList(itemId);
        },
        disabled: indexOfItem == countOfItems - 1,
    };
}
